import React, {Component} from 'react';
import { Row, Col, Badge } from 'reactstrap';
import {connect} from 'react-redux'
import { QueryInitialize_ACTION } from '../Actions/LogisticActions';

var typingTimer;

class AddButtonComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
          Highlight: false
        }

    }

    render(){
        if(this.props.AddedSuccessfuly){
            typingTimer = setTimeout(() => this.props.Initialize(), 1300);
        }
//  
//  onMouseEnter={}
//  onMouseLeave={() => this.setState({Highlight: false})}
        return(
               <Row style = {{
                border:this.state.Highlight ? 1 : 0, borderColor:'red', borderStyle:'dashed',
                flexDirection:'column', alignItems:'center', alignItems:'center'
              }}
                onMouseEnter = {() => this.setState({Highlight: true})}
                onMouseLeave = {() => this.setState({Highlight: false})}  
                
               >
                        <h4
                        style = {{cursor:this.props.IsAdding ? 'arrow' : 'pointer', [this.props.fontSize ? "fontSize" : ""]: this.props.fontSize}}
                        className = {this.state.Highlight ? "border border-secondary border-dashed" : ""} 
                        onClick = {(e) => {
                            if(this.props.IsAdding){
                              return
                            }

                            this.props.onClick()
                          }}>
                          <Badge color = {this.props.IsAdding ? "primary" : (this.props.Color || "success")} >{this.props.IsAdding ? "Processing" :(this.props.Title || "Add")}</Badge>
                        </h4>
                     
                    </Row>
        )
    }
}


function MapStateToProps(state) {
    return {
        AddedSuccessfuly: state.Query.AddedSuccessfuly
  }
}

const MapDispatchToProps = (dispatch) => {
    return {
        Initialize: () => {dispatch(QueryInitialize_ACTION())},
    }
  }

export default connect(MapStateToProps, MapDispatchToProps)(AddButtonComponent)
